<template>
  <div class="app-layout">
    <!-- Overlay mobile -->
    <div class="sidebar-overlay" v-if="sidebarOpen" @click="sidebarOpen = false"></div>

    <SidebarNav
      :isOpen="sidebarOpen"
      :adminName="authStore.adminName"
      :counters="counters"
      @logout="handleLogout"
    />

    <!-- Main content -->
    <main class="main-content">
      <!-- Mobile header -->
      <header class="mobile-header">
        <button class="hamburger" @click="sidebarOpen = !sidebarOpen">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"/></svg>
        </button>
        <span class="mobile-title">El Shaday</span>
      </header>

      <div class="content-area">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import SidebarNav from '../components/ui/SidebarNav.vue'
import { useAuthStore } from '../stores/auth'
import { useParticipantsStore } from '../stores/participants'

export default {
  name: 'AppLayout',
  components: { SidebarNav },
  data() {
    return { sidebarOpen: false }
  },
  computed: {
    authStore() { return useAuthStore() },
    participantsStore() { return useParticipantsStore() },
    counters() {
      return {
        total: this.participantsStore.totalCount,
        pending: this.participantsStore.pendingCount,
        confirmed: this.participantsStore.confirmedCount
      }
    }
  },
  mounted() {
    this.participantsStore.fetchAll()
  },
  watch: {
    '$route'() {
      this.sidebarOpen = false
    }
  },
  methods: {
    handleLogout() {
      this.authStore.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
}
.main-content {
  flex: 1;
  margin-left: 250px;
  display: flex;
  flex-direction: column;
}
.content-area {
  flex: 1;
  padding: var(--spacing-lg);
}
.mobile-header {
  display: none;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-base);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  position: sticky;
  top: 0;
  z-index: 40;
}
.hamburger {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-text-primary);
  padding: var(--spacing-sm);
  display: flex;
}
.mobile-title {
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--color-text-primary);
}
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 45;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
  .mobile-header {
    display: flex;
  }
  .sidebar-overlay {
    display: block;
  }
}
</style>
